export const css = {
    root: '_2P6dmjcb',
    copyright: '_2TICmgUv',
    selector: '_3fnNT1Y4',
    privacypolicy: 'S87aWVsm',
    disclaimer: '_33eipWGx',
    ' _key': 'afcpe-theme/afcpe/lcc-app/footer'
};
export default css;
